import { lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import "./App.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MsalProvider } from "@azure/msal-react";
import { AuthenticatedLayout } from "./auth/AuthenticatedLayout";
import { PublicClientApplication } from "@azure/msal-browser";
import { authConfig } from "./auth/authConfig";

const LayoutComponent = lazy(() => import("./layout/Layout"));
const HomeComponent = lazy(() => import("./routes/home/Home"));
const QualityAssuranceComponent = lazy(
  () => import("./routes/qualityAssurance/QualityAssurance")
);

const queryClient = new QueryClient();

const msalInstance = new PublicClientApplication(authConfig());

const ReleasesApp = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route element={<AuthenticatedLayout />}>
                <Route element={<LayoutComponent />}>
                  <Route index element={<HomeComponent />} />
                  <Route path="qa" element={<QualityAssuranceComponent />} />
                </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </MsalProvider>
  );
};

export default ReleasesApp;
